import React from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import ForwardArrowIcon from "@material-ui/icons/ArrowForward";
import "./Success.css";
import successData from "./Data/Success.json";

const useStyles = makeStyles({
  root: {
    width: 300,
  },
  media: {
    height: 400,
    width: 300,
  },
});

function Success() {
  const classes = useStyles();

  return (
    <div className="success">
      <div className="success__cover">
        <Grid container spacing={10}>
          <Grid item xs={12} md={6}>
            <Typography variant="h4" align="center">
              At MasterClass, Agatha gives agents time to serve customers well
              <Typography variant="subtitle1" align="left">
                Deflecting common questions with AI to improve customer support
                agent efficiency at MasterClass while maintaining CSAT.
              </Typography>
              <Typography variant="button" align="left">
                <Button
                  size="medium"
                  variant="contained"
                  endIcon={<ForwardArrowIcon />}
                  style={{
                    backgroundColor: "#33747f",
                    color: "white",
                    marginBottom: 20,
                  }}
                >
                  Lets chat
                </Button>
              </Typography>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <img
              src="https://assets.website-files.com/5e78c024a853e148aafdb943/5e78c024a853e185e2fdbb54_hero-image-masterclass-2-p-1080.png"
              alt=""
              style={{ height: 280 }}
            />
          </Grid>
        </Grid>
      </div>
      <div className="success__blogs">
        <Grid container spacing={10}>
          {successData.map((successData) => {
            return (
              <Grid item xs={12} sm={6} md={4}>
                <Card className={classes.root}>
                  <CardActionArea>
                    <CardMedia
                      className={classes.media}
                      image={successData.imageUrl}
                      title="Contemplative Reptile"
                    />
                    <CardContent>
                      <Typography variant="subtitle2">
                        {successData.date}
                      </Typography>
                      <Typography gutterBottom variant="h5" component="h2">
                        {successData.name}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        component="p"
                      >
                        {successData.description}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                  <CardActions>
                    <Button
                      size="small"
                      style={{ color: "darkcyan" }}
                      endIcon={<ForwardArrowIcon />}
                    >
                      Read More
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </div>
    </div>
  );
}

export default Success;
